import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "gotozoomoptions"
    }}>{`GoToZoomOptions`}</h1>
    <p>{`Zoom options for the goto destination page.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INHERIT_ZOOM`}</strong>{` = 1212437370`}</p>
      <p parentName="blockquote">{`Inherits the zoom setting from the previously displayed page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_WINDOW`}</strong>{` = 1212437367`}</p>
      <p parentName="blockquote">{`Fits the page in the display window.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_WIDTH`}</strong>{` = 1212437335`}</p>
      <p parentName="blockquote">{`Fits the page to the width of the window; may obscure the lower portion of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_VISIBLE`}</strong>{` = 1212437334`}</p>
      <p parentName="blockquote">{`Fits the text area of the page to the window width; obscures page margins and may obscure the lower portion of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ACTUAL_SIZE`}</strong>{` = 2053206906`}</p>
      <p parentName="blockquote">{`Displays the page at 100% magnification.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      